module.exports = __webpack_public_path__ + "static/media/green_vip_bg.67b68b58.svg";